import { configureStore } from "@reduxjs/toolkit";
import ui from "Store/ui";

const store = configureStore({
  reducer: {
    ui,
  },
});

export default store;
